import { render, staticRenderFns } from "./IssueCreatePdf.vue?vue&type=template&id=4235df96&"
import script from "./IssueCreatePdf.vue?vue&type=script&lang=ts&"
export * from "./IssueCreatePdf.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports